"use strict";

var _interopRequireDefault = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.set");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.to-string");
var _regenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _store = _interopRequireDefault(require("@/store"));
var _user = require("@/api/user");
var _work = require("@/utils/work");
var _notification = require("@/utils/notification");
var nim;
var init = function init(params, addPromptInfo) {
  // console.log('im初始化', process.env.VUE_APP_NIM_FACE_TOKEN)
  nim = window.NIM.getInstance({
    debug: false,
    appKey: process.env.VUE_APP_NIM_KEY,
    account: process.env.VUE_APP_NIM_USER_ID,
    token: process.env.VUE_APP_NIM_FACE_TOKEN,
    onconnect: onConnect,
    onwillreconnect: onWillReconnect,
    ondisconnect: onDisconnect,
    onerror: onError,
    onmsg: onMsg,
    onsessions: onSessions,
    onHistory: onHistory,
    onupdatesession: onupdatesession,
    syncSessionUnread: true,
    syncStickTopSessions: true,
    onStickTopSessions: onStickTopSessions
  });
};
function onConnect() {
  console.log('【网易云】连接成功');
}
function onWillReconnect(obj) {
  // 此时说明 SDK 已经断开连接, 请开发者在界面上提示用户连接已断开, 而且正在重新建立连接
  console.log('即将重连');
  console.log(obj.retryCount);
  console.log(obj.duration);
}
function onDisconnect(error) {
  // 此时说明 SDK 处于断开状态, 开发者此时应该根据错误码提示相应的错误信息, 并且跳转到登录页面
  console.log('丢失连接');
  console.log(error);
  if (error) {
    switch (error.code) {
      // 账号或者密码错误, 请跳转到登录页面并提示错误
      case 302:
        break;
      // 重复登录, 已经在其它端登录了, 请跳转到登录页面并提示错误
      case 417:
        break;
      // 被踢, 请提示错误后跳转到登录页面
      case 'kicked':
        break;
      default:
        break;
    }
  }
}
function onError(error) {
  console.log(error);
}

// 监听
function onMsg(msg) {
  if (_store.default.state.chatNim.remoteAccount && _store.default.state.chatNim.remoteAccount._id + '' === msg.from) {
    // getHistoryMsgsDone(msg.from)
    nim.resetSessionUnread(msg.sessionId);
    _store.default.state.chatNim.historyMessages.push(msg);
  }
}

// function pushMsg(msgs) {
//   if (!Array.isArray(msgs)) { msgs = [msgs] }
//   var sessionId = msgs[0].sessionId
//   data.msgs = data.msgs || {};
//   data.msgs[sessionId] = nim.mergeMsgs(data.msgs[sessionId], msgs)
// }

// 收到会话列表
function onSessions(_x) {
  return _onSessions.apply(this, arguments);
}
function _onSessions() {
  _onSessions = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(list) {
    var filterList;
    return (0, _regenerator2.default)().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          console.log('--- 收到回话列表: ', list.length);
          if (list) {
            _context.n = 1;
            break;
          }
          return _context.a(2);
        case 1:
          _context.n = 2;
          return buildSessions(list);
        case 2:
          filterList = _context.v;
          _store.default.dispatch('chatNim/setMessageList', filterList);
        case 3:
          return _context.a(2);
      }
    }, _callee);
  }));
  return _onSessions.apply(this, arguments);
}
function buildSessions(_x2) {
  return _buildSessions.apply(this, arguments);
} // 历史消息获取
function _buildSessions() {
  _buildSessions = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(sessionList) {
    var ids, chunkData, temp, i, _yield$getUserByIds, code, data;
    return (0, _regenerator2.default)().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          ids = sessionList.map(function (item) {
            return item.to;
          });
          chunkData = (0, _work.createChunks)(ids, 100);
          temp = {};
          i = 0;
        case 1:
          if (!(i < chunkData.length)) {
            _context2.n = 4;
            break;
          }
          _context2.n = 2;
          return (0, _user.getUserByIds)({
            ids: chunkData[i].toString(),
            type: 1
          });
        case 2:
          _yield$getUserByIds = _context2.v;
          code = _yield$getUserByIds.code;
          data = _yield$getUserByIds.data;
          if (code === 0) {
            data.list.forEach(function (item) {
              temp[item._id] = item;
            });
          }
        case 3:
          i++;
          _context2.n = 1;
          break;
        case 4:
          sessionList.forEach(function (item, index) {
            item.targetUserInfo = temp[item.to];
          });
          return _context2.a(2, sessionList.filter(function (item) {
            return item.targetUserInfo;
          }));
      }
    }, _callee2);
  }));
  return _buildSessions.apply(this, arguments);
}
function onHistory(list) {
  list = list.reverse();
  _store.default.dispatch('chatNim/setHistoryMessages', list);
}
function sendText(userId, message, user) {
  nim.sendText({
    scene: 'p2p',
    to: userId,
    text: message
    // done: sendMsgDone
  });
  // console.log('正在发送p2p text消息: ', msg)
  var obj = {
    message: message,
    type: 'text',
    user: user
  };
  _store.default.dispatch('chatNim/addHistoryMessages', obj);
}
function sendImage(userId, url, user) {
  nim.sendFile({
    scene: 'p2p',
    to: userId,
    file: {
      name: '14.jpg',
      size: '38',
      url: url,
      ext: 'jpg',
      w: -1,
      h: -1
    },
    type: 'image'
    // done: sendMsgDone
  });
  // console.log('正在发送p2p file消息: ', msg)
  // const obj = { url, type: 'image', user }
  // store.dispatch('chatNim/addHistoryMessages', obj)
}
function onStickTopSessions(_x3) {
  return _onStickTopSessions.apply(this, arguments);
}
function _onStickTopSessions() {
  _onStickTopSessions = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(e) {
    var topUserIds, i, _yield$getUserByIds2, code, data, validUserIds, invalidUserIds, topList;
    return (0, _regenerator2.default)().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          console.log('--- 校验置顶会话数据：' + e.length);
          topUserIds = [];
          for (i = 0; i < e.length; i++) {
            topUserIds.push(e[i].to);
          }
          if (!topUserIds.length) {
            _context3.n = 2;
            break;
          }
          _context3.n = 1;
          return (0, _user.getUserByIds)({
            ids: topUserIds.toString(),
            type: 2
          });
        case 1:
          _yield$getUserByIds2 = _context3.v;
          code = _yield$getUserByIds2.code;
          data = _yield$getUserByIds2.data;
          if (!(code === 0)) {
            _context3.n = 2;
            break;
          }
          validUserIds = new Set(data.list.map(function (user) {
            return user._id;
          }));
          invalidUserIds = topUserIds.filter(function (userId) {
            return !validUserIds.has(Number(userId));
          });
          e = e.filter(function (item) {
            return validUserIds.has(Number(item.to));
          });
          _context3.n = 2;
          return Promise.all(invalidUserIds.map(function (userId) {
            return deleteStickTopSession('p2p-' + userId);
          }));
        case 2:
          console.log('--- 校验完成置顶数据：' + e.length);
          if (!e.length) {
            _context3.n = 4;
            break;
          }
          _context3.n = 3;
          return buildSessions(e);
        case 3:
          topList = _context3.v;
          _store.default.dispatch('chatNim/SET_MESSAGE_LIST', topList);
        case 4:
          return _context3.a(2);
      }
    }, _callee3);
  }));
  return _onStickTopSessions.apply(this, arguments);
}
function addStickTopSession(id) {
  console.log('触发置顶', id, JSON.stringify({
    id: id,
    time: new Date().getTime()
  }));
  nim.addStickTopSession({
    id: id,
    topCustom: JSON.stringify({
      id: id,
      time: new Date().getTime()
    }),
    done: topCallBackNoticeDone
  });
}
function topCallBackNoticeDone(e) {
  console.log(e);
}
function deleteStickTopSession(id) {
  nim.deleteStickTopSession({
    id: id
  }, function (error) {
    if (!error) {
      console.log('取消置顶成功');
    }
  });
}
function onupdatesession(_x4) {
  return _onupdatesession.apply(this, arguments);
}
function _onupdatesession() {
  _onupdatesession = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4(info) {
    var _yield$getUserByIds3, code, data, options;
    return (0, _regenerator2.default)().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          console.log('触发回调', info);
          // const messageList = store.state.chatNim.messageList
          // const remoteAccount = store.state.chatNim.remoteAccount

          // const current = messageList.findIndex(item => item.id === info.id)
          // if (current >= 0 && messageList[current].targetUserInfo) {
          //   info.targetUserInfo = messageList[current].targetUserInfo
          //   if (messageList[current].unread === 0) {
          //     messageList[current].unread = remoteAccount && remoteAccount._id + '' === info.to ? 0 : info.unread
          //     messageList[current].isTop = info.isTop
          //     store.dispatch('chatNim/setMessageList', messageList)
          //   }
          // }
          if (info.targetUserInfo) {
            _context4.n = 2;
            break;
          }
          _context4.n = 1;
          return (0, _user.getUserByIds)({
            ids: info.to,
            type: 1
          });
        case 1:
          _yield$getUserByIds3 = _context4.v;
          code = _yield$getUserByIds3.code;
          data = _yield$getUserByIds3.data;
          if (code === 0 && data.list.length > 0) {
            info.targetUserInfo = data.list[0];
            // messageList.push(info)
            _store.default.dispatch('chatNim/setMessageList', [info]);
          }
        case 2:
          if (info.targetUserInfo.account_type === 1 && info.targetUserInfo.payCount > 0 && info.lastMsg.from !== '666666') {
            options = {
              body: info.lastMsg.text || '【新的消息】',
              icon: info.targetUserInfo.avatarUrl
            };
            (0, _notification.sendNotification)('用户【' + info.targetUserInfo._id + '】', options);
          }

          // 获取历史消息
          // if (info.targetUserInfo._id === store.state.chatNim.remoteAccount._id) {
          //   getHistoryMsgsDone(info.targetUserInfo._id)
          // }
        case 3:
          return _context4.a(2);
      }
    }, _callee4);
  }));
  return _onupdatesession.apply(this, arguments);
}
function setCurrSession(userId) {
  nim.setCurrSession('p2p-' + userId);
}
function resetUnread(userId) {
  nim.resetSessionUnread('p2p-' + userId, function (err, failId) {
    if (err) {
      console.log('重置失败：', err, '失败的sessionid是', failId);
    }
  });
}

// 获取服务器历史消息
function getHistoryMsgsDone(userId) {
  nim.getHistoryMsgs({
    scene: 'p2p',
    to: userId + '',
    done: function done(error, obj) {
      if (!error) {
        // console.log('获取云端历史记录:' + JSON.stringify(obj.msgs))
        onHistory(obj.msgs);
      }
    }
  });
}
function getEmojiList() {
  return [];
}
var _default = exports.default = {
  init: init,
  onupdatesession: onupdatesession,
  onConnect: onConnect,
  onWillReconnect: onWillReconnect,
  onDisconnect: onDisconnect,
  onMsg: onMsg,
  onSessions: onSessions,
  onHistory: onHistory,
  sendText: sendText,
  sendImage: sendImage,
  getHistoryMsgsDone: getHistoryMsgsDone,
  addStickTopSession: addStickTopSession,
  deleteStickTopSession: deleteStickTopSession,
  resetUnread: resetUnread,
  setCurrSession: setCurrSession,
  getEmojiList: getEmojiList
};